<template>
  <div></div>
</template>

<script setup lang="ts">
const value = defineModel<any>("value");
const form = defineModel<any>("form", {
  default: () => ({}),
});
</script>

<style scoped></style>
